<div *transloco="let t"  class="container py-4">

  <div class="row align-items-center justify-content-between my-2">
    <div class="col-12 col-lg-auto">
      <h2 class="text-primary">Décrire l'organisation</h2>
    </div>
  </div>

  <div class="row align-items-center justify-content-between mb-4">
    <div class="col-12">
      <app-host-cover-field
        [formControl]="hostForm.controls.cover"
        [host]="initialHost()">
      </app-host-cover-field>
    </div>
  </div>

  @if (!!newEmail()) {
    <div class="alert alert-warning mt-2" role="alert">
      <lucide-icon [img]="icons.idea"></lucide-icon>
      L'adresse {{ newEmail() }} sera utilisée une fois l'adresse email validée.
    </div>
  }

  <form [formGroup]="hostForm">
    <app-tabs (selectTab)="save()">
      <app-tab-item
        title="Société"
        [icon]="icons.host"
        [isInvalid]="hostForm.controls.about.invalid">
        <app-host-about-editor [host]="initialHost()"></app-host-about-editor>
      </app-tab-item>
      <app-tab-item
        title="Contact"
        [icon]="icons.contact"
        [isInvalid]="hostForm.controls.contact.invalid">
        <app-host-contact-editor [host]="initialHost()"></app-host-contact-editor>
      </app-tab-item>
    </app-tabs>
  </form>

  <p class="text-end my-2">
    @if (!isFirstTab()) {
      <button
        (click)="goToPrevious()"
        [disabled]="hostForm.invalid"
        type="button"
        class="btn btn-tertiary mx-1">
        <lucide-icon [img]="icons.previous"></lucide-icon>
      </button>
    }
    <button
      (click)="saveAndClose()"
      [disabled]="hostForm.invalid"
      type="button"
      class="btn btn-success mx-1">
      Prévisualiser
      <lucide-icon [img]="icons.preview"></lucide-icon>
    </button>
    @if (!isLastTab()) {
      <button
        (click)="goToNext()"
        [disabled]="hostForm.invalid"
        type="button"
        class="btn btn-tertiary mx-1">
        Suivant
        <lucide-icon [img]="icons.next"></lucide-icon>
      </button>
    }

  </p>
  <p class="text-end my-2">
    <app-contact-support
      [supportEmailSubject]="supportEmailSubject()"
      [supportWhatsappMessage]="supportWhatsappMessage()">
    </app-contact-support>
    <button
      (click)="cancelClick()"
      type="button"
      class="btn btn-link mx-1">
      Annuler
      <lucide-icon [img]="icons.cancel"></lucide-icon>
    </button>
  </p>
</div>
